import { comboName, useSubjectMember } from '@healthblocks-io/core'

export function useSubjectName() {
  const subjectMember = useSubjectMember()
  return subjectMember ? comboName(subjectMember) : ''
}
